import type { CategoryMeta } from "@/types";

export const categories: CategoryMeta[] = [
  {
    type: "movie",
    name: "电影",
    englishName: "Movies",
    slogan: "大银幕的光，值得反复回看",
    intro:
      "从硬核科幻到温柔文艺，榴莲视频为你精选全球佳片。这里有最新上映的口碑之作，也有被时间验证过的经典，帮你在两个小时里，去往另一个世界。",
    icon: "ri-film-line",
    cover:
      "https://readdy.ai/api/search-image?query=atmospheric%20cinema%20hall%20with%20rows%20of%20seats%20and%20a%20glowing%20screen%2C%20deep%20purple%20ambience%20with%20warm%20orange%20beam%20of%20projector%20light%2C%20cinematic%20mood&width=1600&height=600&seq=ld-cat-movie&orientation=landscape",
  },
  {
    type: "tv",
    name: "电视剧",
    englishName: "TV Series",
    slogan: "一集入坑，一夜追完",
    intro:
      "古装权谋、都市情感、悬疑推理、医疗群像，榴莲视频的剧集频道覆盖你所有的追剧偏好，用扎实的故事陪你度过每一个夜晚。",
    icon: "ri-tv-2-line",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20living%20room%20at%20night%20with%20a%20large%20glowing%20tv%20screen%20and%20warm%20lamps%2C%20deep%20purple%20ambience%20with%20orange%20glow%2C%20cinematic%20mood&width=1600&height=600&seq=ld-cat-tv&orientation=landscape",
  },
  {
    type: "variety",
    name: "综艺",
    englishName: "Variety Shows",
    slogan: "快乐和陪伴，从不下线",
    intro:
      "竞技真人秀、音乐竞演、美食纪实、脱口秀，榴莲视频的综艺频道汇集当下最具话题性的节目，让你在笑声与感动里放松下来。",
    icon: "ri-mic-line",
    cover:
      "https://readdy.ai/api/search-image?query=colorful%20tv%20studio%20stage%20with%20lights%20and%20confetti%2C%20deep%20purple%20and%20vivid%20orange%20stage%20lighting%2C%20energetic%20cinematic%20mood&width=1600&height=600&seq=ld-cat-variety&orientation=landscape",
  },
];

export const filterGenres: Record<string, string[]> = {
  movie: ["科幻", "悬疑", "犯罪", "剧情", "家庭", "动作", "冒险", "文艺"],
  tv: ["古装", "权谋", "医疗", "悬疑", "推理", "都市", "爱情", "商战", "科技"],
  variety: ["竞技", "真人秀", "音乐", "竞演", "美食", "生活", "喜剧", "脱口秀", "旅行", "纪实"],
};

export const filterRegions: string[] = [
  "中国大陆",
  "美国",
  "韩国",
  "英国",
  "法国",
  "日本",
];

export const filterYears: number[] = [2025, 2024, 2023];

export const sortOptions = [
  { key: "latest", label: "最新上映" },
  { key: "hot", label: "按热度" },
  { key: "rating", label: "按评分" },
];

export const navLinks = [
  { label: "首页", to: "/" },
  { label: "电影", to: "/category/movie" },
  { label: "电视剧", to: "/category/tv" },
  { label: "综艺", to: "/category/variety" },
  { label: "资讯", to: "/news" },
  { label: "关于", to: "/about" },
];

export const siteIntro = {
  name: "榴莲视频",
  slogan: "最新影视资源在线观看及影视资讯平台",
  description:
    "榴莲视频是一个综合性影视资源在线观看与影视资讯平台，聚合电影、电视剧、综艺等丰富内容。我们相信好的故事值得被更多人看见，也希望用更快的发现、更舒适的浏览，陪你找到下一部想看的作品。",
  email: "hello@durianvideo.example",
  stats: [
    { label: "在库影视", value: "12,000+" },
    { label: "每日更新", value: "200+" },
    { label: "资讯栏目", value: "15+" },
    { label: "注册影迷", value: "380万" },
  ],
};